// A standalone print subtree avoids WebKit paginating Studio's scrollable,
// zoomed mobile preview inside the main app shell. Source is already rendered
// by React; no untrusted HTML parsing, network fetch or second translation set.
const ROOT_ID = 'sj-isolated-print-root';

export function prepareIsolatedJourneyPrint(doc, sourceElement, options = {}) {
  if (!doc?.body || !sourceElement?.cloneNode || !sourceElement?.querySelector) {
    throw new Error('The full Journey preview is not ready to print.');
  }
  const stages = sourceElement.querySelectorAll('.sj-stage-page').length;
  if (!stages || stages !== Number(options.expectedStages)) {
    throw new Error('The printable Journey stages are incomplete. Reload Studio and try again.');
  }
  const notes = sourceElement.querySelector('.sj-notes-page');
  if (!notes || notes.querySelectorAll('.sj-writing-lines > div').length < 2) {
    throw new Error('The notes page is incomplete. Printing has been stopped to avoid a truncated PDF.');
  }
  if (options.requiresSafety && !sourceElement.querySelector('.sj-finish-page .sj-finish-message')) {
    throw new Error('The final clinical safety page is missing. Printing has been stopped.');
  }
  doc.getElementById(ROOT_ID)?.remove();
  const printRoot = doc.createElement('div');
  printRoot.id = ROOT_ID;
  printRoot.setAttribute('aria-hidden', 'true');
  printRoot.className = ['sj-isolated-print', options.largeText ? 'sj-large-text' : '',
    options.multilingual ? 'sj-multilingual' : ''].filter(Boolean).join(' ');
  const clone = sourceElement.cloneNode(true);
  // Screen-only zoom must never leak into a physical A4 export.
  clone.style.zoom = '1';
  clone.style.transform = 'none';
  clone.removeAttribute('aria-label');
  printRoot.appendChild(clone);
  if (clone.querySelectorAll('.sj-stage-page').length !== stages
    || !clone.querySelector('.sj-notes-page')
    || (options.requiresSafety && !clone.querySelector('.sj-finish-page'))) {
    throw new Error('Unable to prepare a complete print copy. No PDF was generated.');
  }
  doc.body.appendChild(printRoot);
  doc.body.classList.add('sj-print-isolated');
  // Do not remove this node in afterprint: iOS may fire that event while its
  // print sheet is still building the PDF. It is screen-hidden, and the next
  // print replaces it after checking the new source.
  return printRoot;
}
